export const locale = {
  lang: 'en',
  data: {
    'HEADER': {
      'TITLE': 'Conciliation registers',
    },
  }
};
